import graphlib from 'graphlib'
import $ from 'jquery'

const strUtil = {
  isNotBlank (str) {
    return !strUtil.isBlank(str)
  },
  // 判断字符串是否为undefined或空字符串或空格
  isBlank (str) {
    return (strUtil.isEmpty(str))
  },
  isEmpty (str) {
    return (str === undefined) || (str === 'undefined') || (str === '')
  }
}
var ZFSN = {
  // 通过id获取jQuery选择器
  getJQSel (id) {
    if (id.indexOf('#') !== 0) {
      id = '#' + id
    }
    return id
  },
  // 获取移除了jQuery选择器前缀的id
  removeJQSel (id) {
    if (id.indexOf('#') === 0) {
      id = id.substring(1)
    }
    return id
  },
  // 使程序睡眠d毫秒
  sleep (d) {
    for (let t = Date.now(); Date.now() - t <= d;);
  },
  // 获取uuid
  getUUID () {
    let s = []
    let hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'
    let uuid = s.join('')
    return uuid.replace(/-/g, '')
  },
  // 获取全局配置
  getConfig () {
    return CONFIG
  }
}
const CONFIG = {
  'defaultConfig': {
    'resizableFlag': false,
    'smallMovePX': 1,
    'testPwd': 'root',
    'language': 'zh_cn'
  },
  'defaultStyle': {
    'selectedBoxShadow': 'rgb(0, 0, 0) 0px 0px 20px 0px',
    'noSelectedBoxShadow': '',
    'dragOpacity': 0.5
  },
  'conn': {
    'stroke': '#999',
    'strokeWidth': 1.5,
    'hoverConnStroke': '#7f9fd5',
    'connectionType': 'Bezier',
    'connectionGap': 5,
    'connectionCornerRadius': 8,
    'connectionAlwaysRespectStubs': true,
    'connectionStub': 30,
    'isDetachable': false
  },
  'arrow': {
    'arrowWidth': 2,
    'arrowLength': 2,
    'arrowLocation': 1
  },
  'endPonit': {
    'fill': '#eee',
    'stroke': 'red',
    'strokeWidth': 1,
    'radius': 5,
    'hoverEndPointStroke': 'pink'
  },
  'anchors': {
    'defaultAnchors': ['Bottom', 'Right', 'Top', 'Left'],
    'sourceAnchors': ['Bottom'],
    'targetAnchors': [],
    'sameAnchorsFlag': true
  },
  'alignParam': {
    'levelDistance': 100,
    'verticalDistance': 100,
    'alignDuration': 500
  },
  'keyboardParam': {
    'multipleSelectedKey': 17,
    'deleteKey': 46,
    'upKey': 38,
    'downKey': 40,
    'leftKey': 37,
    'rightKey': 39,
    'undoKey': 90,
    'redoKey': 89,
    'selectedAllKey': 65,
    'saveKey': 83,
    'save2PhotoKey': 80,
    'clearKey': 68,
    'showGridKey': 81,
    'mouseToolKey': 81,
    'connectionToolKey': 82,
    'settingKey': 70
  }
}
const graphUtil = {
  // 节点的构造函数
  Node (id, cla, type, text, icon, height, width) {
    this.id = id
    this.cla = cla
    this.type = type
    this.text = text
    this.icon = icon
    this.height = height
    this.width = width
  },
  // 连线的构造函数
  Edge (routerId, sourceEndPointId, targetEndPointId, sourceAnchors, targetAnchors) {
    this.routerId = routerId
    this.sourceEndPointId = sourceEndPointId
    this.targetEndPointId = targetEndPointId
    this.sourceAnchors = sourceAnchors
    this.targetAnchors = targetAnchors
  },
  // 添加连线到图对象
  addEdge (sourceId, targetId, edge) {
    let _base = FLOW._base
    _base.graph.setEdge(sourceId, targetId, { // 源节点和目标节点的id
      id: edge.routerId, // 连线id
      sourceEndPointId: edge.sourceEndPointId, // 源节点端点的id
      targetEndPointId: edge.targetEndPointId, // 目标节点端点的id
      sourceAnchors: edge.sourceAnchors, // 源节点的锚点
      targetAnchors: edge.targetAnchors // 目标节点的锚点
    })
  },
  // 更新图对象中的节点
  updateNode (id) {
    let _base = FLOW._base
    let $this = $(ZFSN.getJQSel(id))
    let graphNode = _base.graph.node(ZFSN.removeJQSel(id))
    graphNode.top = $this.offset().top
    graphNode.left = $this.offset().left
  },
  // 更新图对象中的所有节点
  updateAllNode () {
    let _base = FLOW._base
    let nodeArr = _base.graph.nodes()
    for (let i = 0, len = nodeArr.length; i < len; i++) {
      graphUtil.updateNode(nodeArr[i])
    }
  }
}
const plumbUtil = {
  _tempConnObj: {},
  // 允许节点被移动
  ableDraggable (nodeId) {
    let _base = FLOW._base
    let flag = _base.plumb.toggleDraggable(nodeId)
    if (!flag) {
      _base.plumb.toggleDraggable(nodeId)
    }
  },
  // 禁止节点被移动
  unableDraggable (nodeId) {
    let _base = FLOW._base
    let flag = _base.plumb.toggleDraggable(nodeId)
    if (flag) {
      _base.plumb.toggleDraggable(nodeId)
    }
  }
}
const FLOW = {
  _info: {
    author: 'ZFSN',
    version: '2.0'
  },
  _data: {},
  _base: {
    px: '', // 鼠标在画布中的横向坐标
    py: '', // 鼠标在画布中的纵向坐标
    allTimer: {}, // 所有的定时器对象
    isClear: true, // 是否清空画布
    nodeIdPool: {}, // 节点id池
    plumb: {}, // jsPlumb实例对象
    graph: new graphlib.Graph(), // 图形对象
    selectedNodeList: [], // 被选中的节点列表
    selectedMultipleFlag: false, // 全选标识
    allowMultipleSelectedFlag: false, // 允许多选标识
    isSmallMove: false, // 是否产生微移标识
    redoStack: [], // 重做栈
    myclipboard: [], // 剪贴板
    tempFlow: {}, // 微移临时的流程图对象
    tempFlag: true, // 微移临时的标识
    laneObjs: [] // 泳道数组
  },
  render () {
    const text = {
      'noNode': '保存失败，流程图不存在任何节点',
      'noConn': '保存失败，流程图存在未连接的节点',
      'noSetNodeName': '保存失败，请设置节点名称',
      'hasAcyclic': '保存失败，流程图中存在循环路径',
      'noNodeBySave2Photo': '图中无节点，无法保存为图片',
      'deleteConn': '确定要删除连接吗？',
      'deleteLane': '删除成功',
      'deleteNode': '删除成功',
      'chooseNodeObjErr': '节点类型选择错误！',
      'saveSuccess': '流程保存成功',
      'saveObjErr': '发生未知错误，保存失败，请联系管理员',
      'clearConfirm': '确定要重新绘制吗？',
      'noFrontRoute': '无前继路径',
      'noBehindRoute': '无后续路径',
      'alignWayCheck': '请选择两个或两个以上的节点对齐',
      'repeatRouter': '重复路由',
      'closeFrame': '当前流程图还未保存，确认退出吗？',
      'repeatStartNode': '重复的开始节点',
      'currentProgress': '当前进度',
      'noFrontNode': '无前继节点',
      'noBehindNode': '无后续节点',
      'frontNode': '前继节点',
      'behindNode': '后续节点',
      'flowPublish': '流程已完成'
    }
    CONFIG.msg = text
  },
  
  // 清除所有的定时器
  clearAllTimer () {
    let _base = FLOW._base
    let allTimer = _base.allTimer
    // 1、点击画布时清除所有的定时器
    for (let timerName in allTimer) {
      clearTimeout(allTimer[timerName])
    }
    _base.allTimer = {}
  },
  ready (f) { f() },
  init () {
    // // 1、渲染流程设计器
    FLOW.render()
  },
  
}
const com = {
  getVariableList (data, list) {
    for (let key of data) {
      for (let item of key.out) {
        for (let op of item.var) {
          const index = list.findIndex(option => option.name === op.name)
          if (!~index) {
            this.SET_VAR_DATA(op)
          }
        }
      }
    }
  }
}
export {
  graphUtil,
  plumbUtil,
  FLOW,
  ZFSN,
  CONFIG,
  strUtil,
  com
}